import { render, staticRenderFns } from "./LoaderPage.vue?vue&type=template&id=756d4c59&scoped=true"
import script from "./LoaderPage.vue?vue&type=script&lang=js"
export * from "./LoaderPage.vue?vue&type=script&lang=js"
import style0 from "./LoaderPage.vue?vue&type=style&index=0&id=756d4c59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d4c59",
  null
  
)

export default component.exports